import { Col, Row } from "reactstrap";
import React, { useEffect } from "react";
import InputFieldText from "Components/Common/InputFieldText";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import SelectField from "Components/Common/SelectField";
import {
  useLazyGetCGRFConsumerInfo,
  useUtilityConsumerContactInfoQuery,
} from "apis/CGRFGiftPCL";
import { getOptionValue } from "common/enums";

const ComplainantDetails = ({ formik, t, isDisabled }) => {
  const { data: { data: utilityConsumersOptions } = {} } =
    useUtilityConsumerContactInfoQuery({
      utilityId: getOptionValue("utilityOptions", "Power"),
    });

  const [getConsumerInfo] = useLazyGetCGRFConsumerInfo();

  const {
    setFieldValue,
    values: { complainantDetails: { utilityConsumerId } = {} },
  } = formik;

  const onChangeConsumerNumber = async (_, { value }) => {
    try {
      const consumerData = await getConsumerInfo(value);
      const consumerInfo = consumerData?.data?.applicant ?? {};

      setFieldValue(
        "complainantDetails.consumerName",
        consumerInfo?.applicantName
      );
      setFieldValue(
        "complainantDetails.address",
        consumerInfo?.correspondenceAddress
      );
      setFieldValue("complainantDetails.pinCode", consumerInfo?.pinCode);
      setFieldValue(
        "complainantDetails.mobileNumber",
        consumerInfo?.mobileNumber
      );
      setFieldValue("complainantDetails.email", consumerInfo?.email);
    } catch (err) {}
  };

  useEffect(() => {
    (async () => {
      if (utilityConsumerId) {
        try {
          onChangeConsumerNumber(null, { value: utilityConsumerId });
        } catch (error) {}
      }
    })();
  }, [utilityConsumerId]);

  return (
    <>
      <Row>
        <Col md={4} sm={6}>
          <SelectField
            label={t("Consumer Number") + "*"}
            name="complainantDetails.utilityConsumerId"
            formik={formik}
            options={utilityConsumersOptions || []}
            onChange={(_, { value }) => {
              setFieldValue("complainantDetails.utilityConsumerId", value);
            }}
            getOptionLabel={({ consumerNumber }) => consumerNumber}
            getOptionValue={({ id }) => id}
          />
        </Col>

        <Row>
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Name of the Complainant") + "*"}
              name="complainantDetails.consumerName"
              formik={formik}
              disabled
            />
          </Col>
          <Col md={8} sm={12}>
            <InputFieldText
              label={t("Full address of the Complainant") + "*"}
              name="complainantDetails.address"
              formik={formik}
              disabled
            />
          </Col>
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Pin Code") + "*"}
              name="complainantDetails.pinCode"
              formik={formik}
              disabled
            />
          </Col>
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Mobile Number") + "*"}
              name="complainantDetails.mobileNumber"
              formik={formik}
              disabled
            />
          </Col>

          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Email Id") + "*"}
              name="complainantDetails.email"
              formik={formik}
              disabled
            />
          </Col>
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Fax Number")}
              name="complainantDetails.faxNo"
              formik={formik}
              placeholder="Enter fax number"
              disabled={isDisabled}
            />
          </Col>
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Distribution Licensee") + "*"}
              name="complainantDetails.distributionLicensee"
              formik={formik}
              disabled
            />
          </Col>
        </Row>
      </Row>
    </>
  );
};

ComplainantDetails.propTypes = {
  formik: PropTypes.object,
  isDisabled: PropTypes.bool,
  t: PropTypes.func,
};
export default withTranslation()(ComplainantDetails);
